import EmojiAvatar from '@components/EmojiAvatar';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../messages';

const ResourceOverview = ({ resource, selectedResource, handleSelectResource }) => {
  const { _id: resourceId, name, assignedCardsAmount } = resource;
  const isSelectedResource = selectedResource && selectedResource === resourceId;
  const isActive = assignedCardsAmount > 0;
  const intl = useIntl();

  return (
    <div
      className={`grid grid-cols-[20%_80%] my-5 rounded-xl cursor-pointer transition-colors duration-150 ${
        isSelectedResource ? 'bg-indigo-50' : 'hover:bg-slate-50/75'
      }`}
      onClick={() => handleSelectResource(resourceId)}>
      <div className="flex justify-center">
        <div className="w-[47px] h-[47px] mt-1">
          <EmojiAvatar code={resource.emoji || ':credit_card:'} />
        </div>
      </div>
      <div className="text-xs font-medium text-slate-600">
        <div className="text-sm font-semibold text-slate-800 my-1">{name}</div>
        <div
          className={`inline-flex items-center gap-1 px-2.5 py-1 my-1 rounded-md text-xs font-bold border border-solid ${
            isActive
              ? 'bg-emerald-50 text-emerald-700 border-emerald-200/55'
              : 'bg-slate-100 text-slate-500 border-slate-200/55'
          }`}>
          {intl.formatMessage(messages.activeCards)}: {assignedCardsAmount}
        </div>
      </div>
    </div>
  );
};

export default ResourceOverview;
